import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { breakpoints, colors, spacing2020WithoutBreakpoints } from "..";

// OuterContainer:
export const OuterContainer = styled.section`
    background-color: ${({ bgColor }) => bgColor};
    ${({ textColor }) => `color: ${textColor}`}
`;

OuterContainer.defaultProps = {
    bgColor: colors.whiteDuplicate
};

OuterContainer.propTypes = {
    bgColor: PropTypes.string
};

// Container:
const paddingProps = css`
    ${({ removePadding }) => removePadding && "padding: 0;"}

    ${({ removeTopBottomPadding }) =>
        removeTopBottomPadding && "padding-top: 0; padding-bottom: 0;"}


${({ removeLeftRightPadding }) =>
    removeLeftRightPadding && "padding-left: 0; padding-right: 0;"}

    ${({ removeBottomPadding }) => removeBottomPadding && "padding-bottom: 0;"}
`;

export const Container = styled.section`
    margin: 0 auto;
    position: relative;
    width: 100%;
    max-width: 85.38rem; // 1366px

    ${({ isHero }) =>
        isHero &&
        `@media (min-width: 1380px) {
            max-width: 100%;
        }`} 
        /* ^^ the purpose of this is so that the icons in the hero are all shown;
         we will need to refactor once we are using things other than SVGs/using the hero on other pages */

    /* Mobile: */
    ${spacing2020WithoutBreakpoints.SpacingSectionContainerMobile}

    ${paddingProps};
    
    ${({ isHero }) =>
        isHero && spacing2020WithoutBreakpoints.SpacingHeroMobile} 

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        ${spacing2020WithoutBreakpoints.SpacingSectionContainerTablet};

        ${paddingProps};

        ${({ isHero }) =>
            isHero && spacing2020WithoutBreakpoints.SpacingHeroTablet} 
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        ${spacing2020WithoutBreakpoints.SpacingSectionContainerDesktop};

        ${paddingProps};

        ${({ isHero }) =>
            isHero && spacing2020WithoutBreakpoints.SpacingHeroDesktop} 

    }

    /* Screens with 700px - 1000px height range: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.SpacingSectionContainerTablet};
        
        ${paddingProps};

        ${({ isHero }) =>
            isHero && spacing2020WithoutBreakpoints.SpacingHeroTablet} 
        }
    }
`;

Container.defaultProps = {
    removePadding: false,
    removeTopBottomPadding: false,
    removeLeftRightPadding: false,
    isHero: false
};

Container.propTypes = {
    removePadding: PropTypes.bool,
    removeTopBottomPadding: PropTypes.bool,
    removeLeftRightPadding: PropTypes.bool,
    isHero: PropTypes.bool
};
